<template>
  <div class="m-fenxiao">
    <img class="m-fx-banner" src="../../assets/images/fenxiao/banner.png" alt="">
    <div class="m-fx-search">
      <div class="fx-search-title">请选择地区：</div>
      <div class="fx-search-select">
        <el-select v-model="selectProvince" placeholder="请选择省">
          <el-option v-for="item in provinceList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="fx-search-btn" @click="getSchoolList">立即查询</div>
    </div>
    <div class="m-fx-info">
      <div class="fx-info-title">
        <div class="title-icon"></div>
        <div class="title">诚招合作伙伴，欢迎致电垂询：</div>
        <div class="phone-num">400-661-6666</div>
      </div>
      <div class="fx-table-wrap">
        <el-table :data="schoolList" style="width: 100%" border header-cell-class-name="fx-table-header-cell" stripe>
          <el-table-column :fixed="schoolList.length>0?true:false" align="center" prop="city" label="地区" min-width="120px"></el-table-column>
          <el-table-column align="center" prop="name" label="名称" min-width="200px"></el-table-column>
          <el-table-column align="center" prop="address" label="地址" min-width="360px"></el-table-column>
          <el-table-column align="center" prop="tel" label="电话" min-width="160px"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import axios from "axios";
export default {
  data() {
    return {
      pageSource: this.$route.query.type, // 页面来源 sx数校免费区
      schoolList: [],
      selectProvince: '北京',
      tokenTime: 0, // token过期时间的时间戳
      provinceList: [{
        value: '北京',
        label: '北京'
      }, {
        value: '天津',
        label: '天津'
      }, {
        value: '河北',
        label: '河北'
      }, {
        value: '山西',
        label: '山西'
      }, {
        value: '内蒙古',
        label: '内蒙古'
      }, {
        value: '辽宁',
        label: '辽宁'
      }, {
        value: '吉林',
        label: '吉林'
      }, {
        value: '黑龙江',
        label: '黑龙江'
      }, {
        value: '上海',
        label: '上海'
      }, {
        value: '江苏',
        label: '江苏'
      }, {
        value: '浙江',
        label: '浙江'
      }, {
        value: '安徽',
        label: '安徽'
      }, {
        value: '福建',
        label: '福建'
      }, {
        value: '江西',
        label: '江西'
      }, {
        value: '山东',
        label: '山东'
      }, {
        value: '河南',
        label: '河南'
      }, {
        value: '湖北',
        label: '湖北'
      }, {
        value: '湖南',
        label: '湖南'
      }, {
        value: '广东',
        label: '广东'
      }, {
        value: '广西',
        label: '广西'
      }, {
        value: '海南',
        label: '海南'
      }, {
        value: '重庆',
        label: '重庆'
      }, {
        value: '四川',
        label: '四川'
      }, {
        value: '贵州',
        label: '贵州'
      }, {
        value: '云南',
        label: '云南'
      }, {
        value: '西藏',
        label: '西藏'
      }, {
        value: '陕西',
        label: '陕西'
      }, {
        value: '甘肃',
        label: '甘肃'
      }, {
        value: '青海',
        label: '青海'
      }, {
        value: '宁夏',
        label: '宁夏'
      }, {
        value: '新疆',
        label: '新疆'
      }, {
        value: '台湾地区',
        label: '台湾地区'
      }, {
        value: '其他',
        label: '其他'
      }]
    }
  },
  created() {
    this.getToken()
  },
  mounted() {
    document.documentElement.scrollTop = document.body.scrollTop = 0
  },
  methods: {
    // 免费区无登录 通过固定参数获取token
    getToken() {
      axios({
        method:"POST",
        url:'https://school.etiantian.com/authentication-center/authentication/login',
        data: qs.stringify({
          username: '281524fe0a5811e98683cbe20d99d769',
          password: '2815251f0a5811e98683cbe20d99d769'
        }),
        headers: { 'Authorization': 'Basic ' + 'M0RDM0MwRTlDNDMwNTg5ODU0ODA2Q0M4ODVBNEUzOUQ6RjQzRkJFMUM1QkU2REVCNzRERkU4MjgwQzVEMjMwNjg=' }
      }).then(res => {
        window.sessionStorage.setItem('free_token', res.data.access_token)
        this.tokenTime = res.data.expiration
        this.getSchoolList()
      })
    },
    getSchoolList(province) {
      if (new Date().getTime() < this.tokenTime) {
        let _token = "Bearer " + window.sessionStorage.getItem("free_token")
        axios({
          method:"GET",
          url:'https://school.etiantian.com/api-study-service/api/mfq-branch-schools/infos?province=' + this.selectProvince ,
          headers: { 'Authorization': _token }
        }).then(res => {
          this.schoolList = res.data.data
        })
      } else {
        // token过期 重新获取token再请求接口
        this.getToken()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.m-fenxiao {
  width: 100%;
  .m-fx-banner {
    width: 100%;
    display: block;
  }
  .m-fx-search {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: .64rem;
    padding: 0 .48rem;
    .fx-search-title {
      font-size: .28rem;
      color: #4F4F4F;
      flex-shrink: 0;
    }
    .fx-search-select {
      margin-right:.16rem;
      font-size: .28rem;
    }
    .fx-search-btn {
      width: 1.6rem;
      height: .56rem;
      line-height: .56rem;
      text-align: center;
      background: #217cfe;
      color: white;
      border-radius: 2px;
      font-size: .24rem;
      flex-shrink: 0;
    }
  }
  .m-fx-info {
    width: 100%;
    margin:  0 auto;
    margin-top: .52rem;
    margin-bottom: 1.6rem;
    padding: 0 .18rem;
    .fx-info-title {
      display: flex;
      align-items: center;
      font-size: .24rem;
      color: #000;
      margin-bottom: .48rem;
      .title-icon {
        width: .16rem;
        height: .16rem;
        background: #217cfe;
        border-radius: 50%;
        margin-right: .16rem;
      }
      .phone-num {
        color: #217cfe;
        margin-left: .08rem;
      }
    }
    .fx-table-wrap {
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.m-fenxiao {
  .m-fx-search {
    .el-input__inner {
      height: .6rem;
      line-height: .6rem;
    }
    .el-input__icon {
      line-height: .6rem;
    }
  }
  .fx-table-wrap {
    .fx-table-header-cell {
      background: #217cfe;
      font-size: .32rem;
      color: #fff;
    }
    .el-table th, .el-table td {
      padding: .16rem 0;
    }
  }
}
</style>